import { render } from "./tenant.vue?vue&type=template&id=3488b31b&scoped=true"
import script from "./tenant.vue?vue&type=script&lang=js"
export * from "./tenant.vue?vue&type=script&lang=js"

import "./tenant.vue?vue&type=style&index=0&id=3488b31b&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3488b31b"]])

export default __exports__